var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mediaQueries)?_c('span'):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.ownerMenu)}})])}
var staticRenderFns = []

export { render, staticRenderFns }